// extracted by mini-css-extract-plugin
export default {"card":"card_card__Pvkwi","image":"card_image__Mn7LF","desc":"card_desc__G6a6j","title":"card_title__+FJxZ","subTitle":"card_subTitle__BXzT8"};